module.exports = __webpack_public_path__ + "media/assets/icons/checkboxes/disabled-square-d153c89dc09e850f84c8eae50bf1cb6f.svg";